import { ConfirmOrderSave } from "../ConfirmOrderSave";
import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutRetransmitStatusModalOrderSave extends Layout {
    layoutConfirmOrderSave: ConfirmOrderSave;
    retransmitPanel: Panel;
    retransmitWarningLabel: Label;
}
